import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "./index.css";
import { initTheme } from "./theme";
import { closeChatModalOnReload } from "utils/hooks/useBackgroundLocation";
// Initialize theme
initTheme();
// F5 khi đang mở modal chat -> đổi thẳng URL về trang nền trước khi Router mount (xem
// useBackgroundLocation.js), tránh chớp nháy chat rồi mới chuyển trang.
closeChatModalOnReload();


const container = document.getElementById("root");
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
